import { render } from "./NotAllow.vue?vue&type=template&id=24be0d3a&scoped=true"
import script from "./NotAllow.vue?vue&type=script&lang=js"
export * from "./NotAllow.vue?vue&type=script&lang=js"

import "./NotAllow.vue?vue&type=style&index=0&id=24be0d3a&scoped=true&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24be0d3a"]])

export default __exports__